// if our EDS.user is empty, initialize with default values
if( ! ( 'location' in EDS.user ) ) {
    EDS.init( userDetails );
}

Amplitude.init(AmplitudeAnalytics.api_key);